/**
 * Convert số nguyên dương sang chữ tiếng Việt.
 * Đồng bộ với logic backend (DocxTemplateService.NumberToVietnameseWords)
 * để FE preview "Bằng chữ" hiện đúng giống PDF render.
 */
const DIGITS = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
const UNITS = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];

function readThreeDigits(n: number, fillZeros: boolean): string {
  if (n === 0) return '';
  const hundred = Math.floor(n / 100);
  const ten = Math.floor((n % 100) / 10);
  const unit = n % 10;
  let s = '';

  if (hundred > 0) {
    s += DIGITS[hundred] + ' trăm';
    if (ten === 0 && unit > 0) s += ' lẻ';
  } else if (fillZeros) {
    s += 'không trăm';
    if (ten === 0 && unit > 0) s += ' lẻ';
  }

  if (ten > 0) {
    if (s) s += ' ';
    if (ten === 1) s += 'mười';
    else s += DIGITS[ten] + ' mươi';
  }

  if (unit > 0) {
    if (s) s += ' ';
    if (ten >= 1 && unit === 1) s += 'mốt';
    else if (ten >= 1 && unit === 5) s += 'lăm';
    else s += DIGITS[unit];
  }

  return s.trim();
}

export function numberToVietnameseWords(n: number): string {
  if (!isFinite(n) || isNaN(n)) return '';
  if (n === 0) return 'không';
  let integer = Math.floor(Math.abs(n));
  if (integer === 0) return 'không';

  const groups: number[] = [];
  while (integer > 0) {
    groups.push(integer % 1000);
    integer = Math.floor(integer / 1000);
  }

  const parts: string[] = [];
  for (let i = groups.length - 1; i >= 0; i--) {
    if (groups[i] === 0 && i !== 0) continue;
    let g = readThreeDigits(groups[i], i !== groups.length - 1);
    if (i > 0) g += ' ' + UNITS[i];
    parts.push(g);
  }
  let result = parts.join(' ').replace(/\s+/g, ' ').trim();
  return result.charAt(0).toUpperCase() + result.slice(1);
}
